// prettier-ignore
import React, { useEffect, useState } from 'react';
import ProfileImg from '../../../src/assets/images/profile/user-1.jpg';
import {
  Box,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Grid,
} from '@mui/material';

import TableCells from 'src/components/Tables/TableCells';
import CheckboxInputs from 'src/components/inputs/CheckboxInputs';
import { useMain } from '../hooks/useMain';
import { useNavigate } from 'react-router';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import TextInputs from 'src/components/inputs/TextInputs';
import SelectInputs from 'src/components/inputs/SelectInputs';

export const TrimData = (data) => {
  if (data?.length < 25) return data;
  return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
};

const activeDurationTypeMenuOptions = [
  { placeholder: 'Days', value: 'Days' },
  { placeholder: 'Months', value: 'Months' },
];

const FieldData = ({ data, setData, getData, setCheckedOwners, checkedOwners }) => {
  const { deleteOwner, setShowMessage, updateOwnerSubscription } = useMain();

  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [loading, setLoading] = useState(false);

  const naviage = useNavigate();

  const handleDetails = (id) => {
    naviage(`/owner/${id}`);
  };

  const handleDeleteField = async (id) => {
    try {
      const res = await deleteOwner(id);
      if (res?.statusCode === 200) {
        setData(data?.filter((data) => data?._id !== id));
        setShowMessage({
          message: res.message || 'Owner Account deleted Successfully',
          messageType: 'success',
        });
      } else {
        setShowMessage({
          message: res.message || 'Owner Account not deleted',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    }
  };

  const handleUpdate = (item) => {
    setSelectedItemId(item._id);
    const { activeDuration, activeDurationType } = item;
    setUpdateFormData((pre) => ({
      ...pre,
      activeDuration,
      activeDurationType,
    }));
    setOpenDialogue(true);
  };

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdateFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const hadleupdateData = async () => {
    setLoading(true);
    try {
      const res = await updateOwnerSubscription(updateFormData, selectedItemId);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Owner Details updated successfully',
          messageType: 'success',
        });
        setData([]);
        getData();
      } else {
        setShowMessage({
          message: res.message | 'Owner details not Updated',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setLoading(false);
      setOpenDialogue(false);
    }
  };

  const handleAllCheckboxChange = () => {
    if (isAllChecked) {
      setCheckedOwners([]);
    } else {
      setCheckedOwners(data);
    }
    setIsAllChecked(!isAllChecked);
  };

  const handleSignleCheckboxChange = (ownerId) => {
    if (checkedOwners.length && checkedOwners.some((check) => check._id === ownerId)) {
      setCheckedOwners((prev) => prev.filter((check) => check._id !== ownerId));
    } else {
      const checked = data.filter((item) => item._id === ownerId);
      setCheckedOwners((prev) => [...prev, ...checked]); // Create a new array
    }
  };

  useEffect(() => {
    setIsAllChecked((data?.length && checkedOwners?.length === data?.length) || false);
  }, [checkedOwners.length, data?.length]);

  return (
    <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
      <table className="table-container mt-3">
        <thead className="table-thead">
          <tr>
            <th style={{ width: '5%' }}>
              <CheckboxInputs
                type={'Heading'}
                isAllChecked={isAllChecked}
                handleAllCheckboxChange={handleAllCheckboxChange}
              />
            </th>
            <th style={{ width: '17%', textAlign: 'center' }}>Name</th>
            <th style={{ width: '10%', textAlign: 'center' }}>Phone</th>
            <th style={{ width: '20%', textAlign: 'center' }}>Email</th>
            <th style={{ width: '8%', textAlign: 'center' }}>Status</th>
            <th style={{ width: '10%', textAlign: 'center' }}>Remaining Duration</th>
            <th style={{ width: '10%', textAlign: 'center' }}>Subscription Last Date</th>
            <th style={{ width: '10%', textAlign: 'center' }}>Message Sent</th>
            <th style={{ width: '10%', textAlign: 'center' }}>Actions</th>
          </tr>
        </thead>
        <tbody className="table-tbody">
          {data.map((item) => {
            return (
              <tr key={item._id}>
                <td style={{ width: '5%', textAlign: 'center' }}>
                  <CheckboxInputs
                    type={'content'}
                    handleSignleCheckboxChange={handleSignleCheckboxChange}
                    checkedItems={checkedOwners}
                    fieldId={item?._id}
                  />
                </td>
                <td style={{ width: '17%', display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <Avatar
                    src={item?.logo ? item?.logo?.url : ProfileImg}
                    alt={item?.logo ? item?.logo?.url : ProfileImg}
                    sx={{
                      width: 50,
                      height: 50,
                    }}
                  />
                  {TrimData(item?.name)}
                </td>
                <td style={{ width: '10%', textAlign: 'center' }}>{item?.phone}</td>
                <td style={{ width: '20%', textAlign: 'center' }}>{TrimData(item?.email)}</td>
                <td style={{ width: '8%', textAlign: 'center' }}>{item?.activeStatus}</td>
                <td style={{ width: '10%', textAlign: 'center' }}>
                    {item?.remainingMonths > 1 ? `${item?.remainingMonths} months` : `${item?.remainingMonths} month`}
                    {item?.remainingDays > 1 ? ` ${item?.remainingDays} days` : ` ${item?.remainingDays} day`}
                </td>
                <td style={{ width: '10%', textAlign: 'center' }}>{item?.subscriptionDetails?.endDate}</td>
                <td style={{ width: '10%', textAlign: 'center' }}>{item?.sentSmsCount}</td>
                <td style={{ width: '10%', textAlign: 'center' }}>
                  <TableCells
                    type="button"
                    handleDeleteField={handleDeleteField}
                    handleUpdate={() => handleUpdate(item)}
                    handleDetails={handleDetails}
                    field={item?._id}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {/* ---------------------- Owner Details Dialog ---------------- */}
      <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
        <DialogTitle>Owner Details</DialogTitle>
        <DialogContent>
          <DialogContentText>Here you can update Owner details.</DialogContentText>
          {/* <Box style={{ marginTop: '20px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Name'}
                  name={'name'}
                  value={updateFormData?.name}
                  handleChange={handleChange}
                  type={'text'}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Contact Number'}
                  name={'phone'}
                  value={updateFormData?.phone}
                  handleChange={handleChange}
                  type={'number'}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Email Address'}
                  name={'email'}
                  value={updateFormData?.email}
                  handleChange={handleChange}
                  type={'email'}
                  disabled={true}
                />
              </Grid>
            </Grid>
          </Box> */}

          <Box style={{ marginTop: '20px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextInputs
                  title={'Active Duration'}
                  name={'activeDuration'}
                  placeholder="0"
                  min={0}
                  value={updateFormData?.activeDuration}
                  handleChange={handleChange}
                  type={'number'}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <SelectInputs
                  title={'Active Duration Type'}
                  name={'activeDurationType'}
                  value={updateFormData?.activeDurationType}
                  handleChange={handleChange}
                  options={activeDurationTypeMenuOptions}
                  optionTitle={'placeholder'}
                  optionValue={'value'}
                />
              </Grid>

              {/* <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Upload Photo (max size: 1MB)'}
                  name={'images'}
                  value={updateFormData?.images || ' '}
                  handleChange={handleImage}
                  type={'file'}
                  required={false}
                />
              </Grid> */}
              {/* <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Add Link'}
                  name={'link'}
                  value={updateFormData?.link}
                  handleChange={handleChange}
                  type={'text'}
                  required={false}
                />
              </Grid> */}
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          {loading ? (
            <ShowLoader />
          ) : (
            <>
              <div style={{ width: '200px', margin: '3rem auto' }}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleCloseDialogue}
                >
                  Cancel
                </Button>
              </div>
              <div style={{ width: '200px', margin: '3rem auto' }}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={hadleupdateData}
                >
                  update
                </Button>
              </div>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FieldData;
